// *******~ Import ~******** //
// React
import React, {
  useState,
  useContext,
  createContext,
  useEffect,
  useRef,
} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// Assets
// Components
import Main from "./main";
import Sitemap from "../src/pages/seo/sitemap";
// import {ThemeSetter} from "./common/theme/components/themeshetter";
import ThemeProvider from "./common/theme/components/contexts/themeprovider";
import {
  // PaymentRequestButtonElement,
  useStripe,
  // useElements,
} from "@stripe/react-stripe-js";

import { connect } from "react-redux";
import { setStripe } from "./actions/stripe/setStripeActions";
import { isIOS } from "react-device-detect";

// CSS
// Images
// Icons
// *******~ Import ~******** //
export const OrderFlowProvider = createContext({});
export const OrderFlow = () => useContext(OrderFlowProvider);

const App = ({ setStripe }) => {
  const stripe = useStripe();
  const mobileref = useRef();
  const loginCheck1 = localStorage.getItem("isLoggedIn");
  const loginCheck = loginCheck1 === "true";
  // const location = useLocation();
  // const elements = useElements();
  useEffect(() => {
    if (stripe) {
      setStripe(stripe); // Dispatch the Stripe object to Redux
    }
  }, [stripe, setStripe]);

  const font = {
    font_family_name: '"Inter", sans-serif',
    font_family_size: "300",
    font_family_weight: "normal",
    font_family_url:
      '<link rel="preconnect" href="https://fonts.googleapis.com">\r\n<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>\r\n<link href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet">',
    font_layout: "overall_layout",
  };

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--theme-font-family",
      '"Inter", sans-serif'
    );
    document.body.style.setProperty(
      "font-family",
      '"Inter", sans-serif',
      "important"
    );
  }, []);

  useEffect(() => {
    function getiOSVersion() {
      const match = navigator.userAgent.match(/OS (\d+)_/i);
      if (match && match.length > 1) {
        return parseInt(match[1], 10);
      }
      return null;
    }

    // const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent) && !window.MSStream;

    const iOSVersion = getiOSVersion();
    if (isIOS && iOSVersion && iOSVersion >= 15) {
      document.body.classList.add("ios-app");
      const currentPath = window.location.pathname;
      const AppCheck = currentPath?.endsWith("/app");
      if (AppCheck && !loginCheck) {
        document.body.classList.add("ios-15-up");
      } else {
        document.body.classList.remove("ios-15-up");
      }
    } else if (isIOS) {
      document.body.classList.add("ios-below-15");
    }
  }, [window.location.pathname, loginCheck]);

  const [loginPopupShow, setLoginPopupShow] = useState(false);
  const [appLoginPopupShow, setAppLoginPopupShow] = useState(false);
  const [currentPage, setCurrentPage] = useState("signIn"); // "signIn" or "otp"
  const [getOrderTime, setOrderTime] = useState(
    localStorage.getItem("orderTime")
  );
  const [getOrderMode, setOrderMode] = useState(
    localStorage.getItem("orderMode")
      ? localStorage.getItem("orderMode")
      : "Delivery"
  );
  const [getCollectionTab, setCollectionTab] = useState(true);
  const [getDeliveryTab, setDeliveryTab] = useState(true);
  const [moveToCheck, setMoveToCheck] = useState(
    localStorage.getItem("moveToCheck")
      ? localStorage.getItem("moveToCheck")
      : false
  );
  //menufilterShow mobile
  const [menuFilterShow, setMenuFilterShow] = useState(false);
  const [stuartStatus, setStuartStatus] = useState(false);
  const [restaurant, setRestaurant] = useState(null);
  const [footerLoading, setFooterLoading] = useState(false);
  //postcode change
  const [reslimit, setReslimit] = useState(1);
  const [restaurantData, setRestaurantData] = useState([]);
  const [hasFetchedData, updateHasFetchedData] = useState(false);
  const [cartQuantity, setCartQuantity] = useState(null);
  const [lastOrder, setLastOrder] = useState(false);
  useEffect(() => {
    setFooterLoading(false);
    setCartQuantity(localStorage.getItem("cartQty"));
  }, []);
  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        //  setIpAddress(data.ip);
        localStorage.setItem("ip", data.ip);
      })
      .catch((error) => {
        console.error("Error fetching IP address:", error);
      });
  }, []);
  useEffect(() => {
    // console.log(footerLoading);
    const root = document.documentElement;
    root.style.setProperty("--theme-background", "black");
    root.style.setProperty("--theme-color", "white");
  }, []);
  const handleclick = () => {
    setFooterLoading(false);
  };
  const TopQty = () => {
    const cartQty = localStorage.getItem("cartQty");
    setCartQuantity(cartQty);
  };
  const menuFooter =
    !window.location.pathname.includes("/menu") &&
    !window.location.pathname.includes("/checkout") &&
    !window.location.pathname.includes("/myaccount");
  return (
    <>
      <ThemeProvider>
        <OrderFlowProvider.Provider
          value={{
            loginPopupShow,
            setLoginPopupShow,
            getOrderTime,
            setOrderTime,
            getOrderMode,
            setOrderMode,
            getCollectionTab,
            setCollectionTab,
            getDeliveryTab,
            setDeliveryTab,
            moveToCheck,
            setMoveToCheck,
            stuartStatus,
            setStuartStatus,
            restaurant,
            setRestaurant,
            footerLoading,
            setFooterLoading,
            handleclick,
            reslimit,
            setReslimit,
            restaurantData,
            setRestaurantData,
            hasFetchedData,
            updateHasFetchedData,
            mobileref,
            cartQuantity,
            setCartQuantity,
            TopQty,
            lastOrder,
            setLastOrder,
            menuFooter,
            appLoginPopupShow,
            setAppLoginPopupShow,
            currentPage,
            setCurrentPage,
            menuFilterShow,
            setMenuFilterShow,
          }}
        >
          <Router basename={"/"}>
            <Routes>
              <Route path="/sitemap.xml" element={<Sitemap />} />
              <Route path="/*" element={<Main />} />
            </Routes>
          </Router>
        </OrderFlowProvider.Provider>
      </ThemeProvider>
    </>
  );
};

const mapDispatchToProps = {
  setStripe,
};

export default connect(null, mapDispatchToProps)(App);
